import styled from 'styled-components'

import device from 'utils/device'
import Header from 'components/Header'
import Start from 'components/Start'
import Rich from 'components/Rich'

export default function TextPage({ children, html }) {
    return (
        <>
            <Full>
                <Header />
                <SmallWrap>
                    {children}
                    <Rich>{html}</Rich>
                </SmallWrap>
                <CircleBig />
                <CircleSmall />
            </Full>
            <Start />
        </>
    )
}

const Full = styled.div`
    width: var(--full);
    margin: 0 auto;
    position: relative;
    padding-bottom: 1.6rem;
    img {
        width: 100%;
        height: auto;
        max-width: 500px;
    }
    ${device.mobile} {
        width: var(--wrap-mobile);
        padding-bottom: 0.8rem;
    }
`

const CircleBig = styled.div`
    width: 2.2rem;
    height: 2.2rem;
    background: var(--color-blue);
    border-radius: 50%;
    position: absolute;
    right: 0;
    top: 0;
    ${device.mobile} {
        width: 1.2rem;
        height: 1.2rem;
        margin-right: -0.16rem;
    }
`

const CircleSmall = styled.div`
    width: 0.8rem;
    height: 0.8rem;
    background: var(--color-accent);
    border-radius: 50%;
    position: absolute;
    right: 2.02rem;
    top: 0;
    ${device.mobile} {
        width: 0.4rem;
        height: 0.4rem;
        margin-right: -0.16rem;
        right: 1.09rem;
    }
`

const SmallWrap = styled.div`
    width: 7.92rem;
    margin: 0 auto;
    padding-top: 0.32rem;
    position: relative;
    z-index: 1;
    h1 {
        margin: 0 0 0.36rem;
    }
    ${device.mobile} {
        width: auto;
    }
`
